import {
  useEffect,
  useRef,
  useState
} from "react";

import { BoxedContent } from "@/components/common";
import { DynamicFormContainer } from "@/components/dynamic";
import dynamicObjectMap from "@/utils/maps/dynamicObjectMap";

import { useCompanyAccount } from "@/hooks";

function LeadForm() {
  const ref = useRef(null);
  const [initialState, setInitialState] = useState({});
  const defaultAccounts = useCompanyAccount({
    params: {
      includeCompanyId: true,
      isLinkedWithRecord: false
    }
  });

  useEffect(() => {
    if (defaultAccounts && !initialState.areAccountsSelected) {
      const { customerReceivable, customerRefund } = defaultAccounts;

      setInitialState((prevState) => ({
        ...prevState,
        areAccountsSelected: true,
        receivableAccount: customerReceivable,
        customerRefundAccount: customerRefund,
      }));
    }
  }, [defaultAccounts]);

  return (
    <BoxedContent>
      <DynamicFormContainer
        ref={ref}
        initialData={initialState}
        objectName={dynamicObjectMap.get("LeadObjectName")}
        showHeader
      />
    </BoxedContent>
  );
}

export default LeadForm;
